import { Dispatch, MutableRefObject, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

import BackPage from "../../components/button/BackPage";
import { MSelect } from "../../components/form";
import { useGetSaleLangOption } from "../../features/sales/hooks/useGetSaleLang";
interface IProps {
    setHasChangedPage?: Dispatch<SetStateAction<boolean>>;
    prevTab?: MutableRefObject<number>;
}
const DEFAULT_SALE_LANG = "zh-TW";
const SaleLanguageTabs = ({ setHasChangedPage, prevTab }: IProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { orgId } = useParams();
    //const { isSubmitDisabled } = useDetailsCtx();
    const { state, pathname } = useLocation();

    const [searchParams] = useSearchParams();
    const { names } = useGetSaleLangOption();

    const languageOptions =
        names?.map((row) => ({
            label: row.name,
            value: row.lang,
        })) || [];

    const selectedLang = searchParams.get("lang") || DEFAULT_SALE_LANG;

    const handleLanguageChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newLang = e.target.value;
        setHasChangedPage && setHasChangedPage(true);
        navigate(`${pathname}?lang=${newLang}`);
    };

    const backUrl = state ? `/sale/${state}` : `/sale/org/${orgId}/item`;
    const isNoLangTab = pathname.includes("/completed");

    return (
        <>
            <BackPage path={backUrl} />
            {!isNoLangTab && (
                <>
                    {/* <MAlert severity='info' sx={{ mt: 2, mb: 2 }}>
                        {t("COMMON.Save_Before_Switch_Language")}
                    </MAlert> */}
                    <MSelect
                        name='language'
                        label={t("COMMON.Language") || "語言"}
                        value={selectedLang}
                        onChange={handleLanguageChange}
                        options={languageOptions}
                        variant='outlined'
                        required={false}
                        sx={{ maxWidth: "300px", mb: 2 }}
                    />
                </>
            )}
        </>
    );
};

export default SaleLanguageTabs;
